import axiosInstance from '../utils/axiosConfig';
import { Category, Page, SingleCategoryResponse } from '../types/category';
import  { AxiosError } from 'axios';



export const categoryApi = {
  getAllCategories: async (page: number = 0, size: number = 9): Promise<Page<Category>> => {
    const response = await axiosInstance.get('/api/categories', {
      params: { page, size }
    });
    return response.data;
  },

    getAllCategoriesForUser: async (page: number = 0, size: number = 9, questionType: string = 'payed'): Promise<Page<Category>> => {
    // Check if user is authenticated
    const isAuthenticated = !!localStorage.getItem('token');
    
    // Use public endpoint if not authenticated
    const endpoint = isAuthenticated 
      ? '/api/categories/user-category' 
      : '/api/categories/public';
    
    const response = await axiosInstance.get(endpoint, {
      params: { page, size, questionType }
    });
    return response.data;
  },

  getCategoryById: async (id: string): Promise<SingleCategoryResponse> => {
    const response = await axiosInstance.get(`/api/categories/${id}`);
    return response.data;
  },

  createCategory: async (category: Category): Promise<SingleCategoryResponse> => {
    const response = await axiosInstance.post('/api/categories', category);
    return response.data;
  },

  uploadCategoryThumbnail: async (categoryId: string, file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    
    try {
        const response = await axiosInstance.post(
            `/api/categories/${categoryId}/add-photo`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: [(data) => data],
            }
        );
        return response.data;
    } catch (error) {
        if (error instanceof AxiosError) {
            throw new Error(error.response?.data?.message || 'Failed to upload category thumbnail');
        }
        throw new Error('Unexpected error occurred');
    }
  },

  updateCategory: async (id: string, category: Category): Promise<SingleCategoryResponse> => {
    const response = await axiosInstance.put(`/api/categories/${id}`, category);
    return response.data;
  },

    deleteCategory: async (id: string): Promise<SingleCategoryResponse> => {
    const response = await axiosInstance.delete(`/api/categories/${id}`);
    return response.data;
  
    },

 getListCategory: async (categoryIds: string[]): Promise<Category[]> => {
    try {
      const response = await axiosInstance.get('/api/categories/category-list', {
        params: {
          'categoryIds[]': categoryIds
        },
        paramsSerializer: {
          indexes: null // This helps with correct array parameter serialization
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}; 